// The bounds of a masking find (CT-028, module-7 7a), in a file of their own: the contract validates with them
// (contracts/widget.ts, on the server) and the drawer trims to them (masking/dom.ts), and neither may load the
// other's dependencies (Zod for the drawer, the DOM types for the server). The loader never imports this file.

/** Selector and page path, label (already masked), finds per report, allowed places in the config. */
export const MASKING_FIND_LIMITS = { placeChars: 300, labelChars: 120, finds: 200, allowed: 500 } as const;
